import { aicsHttp } from '../base';

// ==================== 席位管理 API ====================

/**
 * 获取工作区的客服席位列表
 * @param {string} workspaceSlug 知识库slug
 * @param {number} tenantId 租户ID
 */
export function getSeatList(workspaceSlug, tenantId) {
  return aicsHttp({
    url: `/aics/seat/list/${workspaceSlug}`,
    method: 'get',
    params: { tenantId }
  });
}

/**
 * 创建客服席位
 * @param {Object} data 席位数据
 * @param {number} tenantId 租户ID
 * @param {string} userName 用户名
 */
export function createSeat(data, tenantId, userName) {
  return aicsHttp({
    url: `/aics/seat/create`,
    method: 'post',
    params: { tenantId, userName },
    data
  });
}
/**
 * 更新客服席位
 * @param {Object} data 席位数据
 * @param {number} tenantId 租户ID
 */
export function updateSeat(data, tenantId) {
  const formData = new FormData();
  
  // 1. 分离文件字段和普通字段
  const seatData = {};
  const files = {};
  
  Object.keys(data).forEach(key => {
    if (key === 'icon_file' || key === 'banner_file') {
      // 文件字段单独处理
      if (data[key]) {
        files[key] = data[key];
        formData.append(key, data[key]);
      }
    } else {
      // 普通字段放入 seat 对象
      seatData[key] = data[key];
    }
  });
  
  // 2. 将 seat 对象转换为 JSON 字符串，作为 "seat" 参数
  formData.append('seat', JSON.stringify(seatData));
  
  // 3. 添加 tenantId 参数
  formData.append('tenantId', tenantId.toString());
  
  // 打印调试信息
  console.log('FormData contents:');
  for (let pair of formData.entries()) {
    console.log(pair[0] + ': ' + (pair[0] === 'seat' ? pair[1] : (pair[1] instanceof File ? pair[1].name : pair[1])));
  }
  
  return aicsHttp({
    url: `/aics/seat/update`,
    method: 'put',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

/**
 * 删除客服席位
 * @param {number} id 席位ID
 * @param {number} tenantId 租户ID
 */
export function deleteSeat(id, tenantId) {
  return aicsHttp({
    url: `/aics/seat/delete/${id}`,
    method: 'delete',
    params: { tenantId }
  });
}

/**
 * 启用/禁用席位
 * @param {number} id 席位ID
 * @param {number} tenantId 租户ID
 * @param {boolean} isActive 是否启用
 */
export function toggleSeat(id, tenantId, isActive) {
  return aicsHttp({
    url: `/aics/seat/toggle/${id}`,
    method: 'post',
    params: { tenantId, isActive }
  });
}

/**
 * 获取席位嵌入代码
 * @param {number} id 席位ID
 * @param {number} tenantId 租户ID
 */
export function getSeatEmbedCode(id, tenantId) {
  return aicsHttp({
    url: `/aics/seat/embed-code/${id}`,
    method: 'get',
    params: { tenantId }
  });
}

/**
 * 获取租户席位数量统计
 * @param {number} tenantId 租户ID
 * @param {string} userName 用户名（可选）
 */
export function countSeatByTenant(tenantId, userName) {
  return aicsHttp({
    url: '/aics/seat/count_by_tenant',
    method: 'get',
    params: { tenantId, userName }
  });
}

/**
 * 创建席位（宣传模式：绑定已有知识库）
 * @param {Object} data 席位数据
 * @param {number} tenantId 租户ID
 * @param {string} userName 用户名
 */
export function createSeatWithExisting(data, tenantId, userName) {
  console.log("createSeatWithExisting", data, tenantId, userName)
  return aicsHttp({
    url: '/aics/seat/create-with-existing',
    method: 'post',
    params: { tenantId, userName },
    data
  });
}

/**
 * 创建席位（店铺模式：创建新知识库）
 * @param {Object} data 席位数据
 * @param {string} workspaceName 新知识库名称
 * @param {number} tenantId 租户ID
 * @param {string} userName 用户名
 */
export function createSeatWithNew(data, workspaceName, tenantId, userName, iconFile, bannerFile) {
    console.log("createSeatWithNew", data, iconFile, bannerFile)
  return aicsHttp({
    url: '/aics/seat/create-with-new',
    method: 'post',
    params: { tenantId, userName, workspaceName },
    data
  });
}

// ==================== 席位设计配置 API（预留） ====================

/**
 * 获取席位设计配置
 * @param {number} seatId 席位ID
 */
export function getSeatDesign(seatId) {
  return aicsHttp({
    url: `/aics/seat/design/${seatId}`,
    method: 'get'
  });
}

/**
 * 保存席位设计配置
 * @param {Object} data 设计配置
 */
export function saveSeatDesign(data) {
  return aicsHttp({
    url: '/aics/seat/design/save',
    method: 'post',
    data
  });
}

